import { render, staticRenderFns } from "./widget-list.vue?vue&type=template&id=c21e61e8&scoped=true&"
import script from "./widget-list.ts?vue&type=script&lang=ts&"
export * from "./widget-list.ts?vue&type=script&lang=ts&"
import style0 from "./widget-list.scss?vue&type=style&index=0&id=c21e61e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21e61e8",
  null
  
)

export default component.exports